import {
  AdgroupFormData,
  CreateMode,
  DefaultInterestKeywordsTraceInfo,
  InterestKeywordsTraceInfo
} from '@tt4b/ttam-enums';
import { cloneDeep, intersection } from 'lodash-es';
import { trackEvent } from './../../../../utils/index';
import { ref, Ref } from '@vue/composition-api';

const interestKeywordsTraceInfo: Ref<InterestKeywordsTraceInfo> = ref(cloneDeep(DefaultInterestKeywordsTraceInfo));

export function useRecommendInterestKeywordTrack(props: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = props;
  function resetTraceInfo() {
    interestKeywordsTraceInfo.value = cloneDeep(DefaultInterestKeywordsTraceInfo);
  }

  const sendTraceEvent = (options: { adgroupIds: string | string[]; createMode: CreateMode }) => {
    const { adgroupIds, createMode } = options;
    const { interestKeywordsI18n } = adgroupData.value;
    (Array.isArray(adgroupIds) ? adgroupIds : [adgroupIds]).forEach(adgroupId => {
      const recommendedKeywords = intersection(
        interestKeywordsTraceInfo.value.recommendedKeywords,
        interestKeywordsI18n
      );

      trackEvent('applied_interest_keywords_recommendation_on_submitted', {
        adgroup_id: adgroupId,
        recommended_keywords: JSON.stringify(recommendedKeywords),
        all_selected_keywords: JSON.stringify(interestKeywordsI18n),
        penetration_rate: recommendedKeywords.length / interestKeywordsI18n.length,
        create_mode: createMode,
      });
    });

    resetTraceInfo();
  };

  function updateRecommendTraceInfo(recommendedKeywords: number[]) {
    const traceInfo = cloneDeep(interestKeywordsTraceInfo.value);
    traceInfo.tracer = sendTraceEvent;
    traceInfo.recommendedKeywords = [...traceInfo.recommendedKeywords, ...recommendedKeywords];
    interestKeywordsTraceInfo.value = traceInfo;
  }

  return {
    resetTraceInfo,
    updateRecommendTraceInfo,
    sendTraceEvent,
    interestKeywordsTraceInfo,
  };
}
